// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4u-2";
export var blackBorderOnHover = "_4u-7";
export var cell = "_4u-6";
export var cellContainer = "_4u-3";
export var checked = "_4u-8";
export var disabled = "_4u-5";
export var featuredIconCellContainer = "_4u-9";
export var featuredIconTextContainer = "_4u-b";
export var featuredIconWrapper = "_4u-a";
export var noBorder = "_4u-c";
export var orangeSelectedRow = "_d1-3";
export var overflowableText = "_4u-0";
export var overflowableTextContainer = "_4u-1";
export var row = "_4v-0";
export var rowCheckboxCell = "_4u-4";
export var selectableTable = "_d1-2";